import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerNavigatorApp} from '@github-ui/react-core/register-app'

import {App} from './App'
import {AttestationDetail} from './pages/AttestationDetail'
import {AttestationsIndex} from './pages/AttestationsIndex'

registerNavigatorApp('repo-attestations', () => {
  return {
    App,
    routes: [
      jsonRoute({
        path: '/:owner/:repo/attestations',
        Component: AttestationsIndex,
      }),
      jsonRoute({path: '/:owner/:repo/attestations/:attestation_id', Component: AttestationDetail}),
    ],
  }
})
